import detailStyles from '../ChallengeDetail.module.scss';
import image121 from './images/12-1.jpg';
import image131Telegram from './images/13-1-telegram.jpg';
import image131Max from './images/13-1-max.jpg';
import image132 from './images/13-2.jpg';
import { ChallengeDetailHelpImage } from './ChallengeDetailHelpImage';
import { isMaxPlatform } from '../../../../platform/platform';

export const JoinChannelsDescription = () => {
    const image131 = isMaxPlatform() ? image131Max : image131Telegram;

    return (
        <div className={detailStyles.description}>
            <p>
                <div>
                    Перейдите в раздел <b>«Заработок»</b>
                </div>
                <ChallengeDetailHelpImage image={image121} helpText='Это картинка. Ищите меню разделов в игре.' />
            </p>

            <p>
                <div>
                    Зайдите в подраздел <b>«Подписаться на канал»</b>
                </div>
                <ChallengeDetailHelpImage image={image131} helpText='Это картинка. Ищите подраздел в разделе «Заработок».' />
            </p>
            
            <p>
                <div>
                    Подпишитесь на любой канал и нажмите кнопку <b>«Проверить»</b>
                </div>
                <ChallengeDetailHelpImage image={image132} helpText='Это картинка. Ищите кнопку в подразделе «Подписаться на канал».' />
            </p>
        </div>
    );
}